import { fetcher } from '#lib/backendFetcher';

/**
 * Resolves free-text industry terms to explicit WZ-2025 codes and prefixes.
 * Backend pipeline: curated lookup → RAG → optional LLM rerank; non-curated
 * terms take ~1-3s, so callers should debounce and cache (see resolveIndustryOptions).
 *
 * @param {string[]} industrySearchTerms - Parsed, trimmed free-text terms (max 10)
 * @returns {Promise<{primaryCodes: string[], secondaryCodes: string[], expandedCodes: string[], codePrefixes: string[], queryType: string, confidence: number}>}
 */
export const resolveIndustryTerms = async (industrySearchTerms) => {
	return await fetcher('/api/v1/search/unified/resolveIndustry', {
		method: 'POST',
		body: { industrySearchTerms },
	});
};
